export const DASHBOARD_SET_ERROR = 'DASHBOARD_SET_ERROR';
export const DASHBOARD_RESET = 'DASHBOARD_RESET';
export const DASHBOARD_SET_LOADING = 'DASHBOARD_SET_LOADING';
export const DASHBOARD_SET_ITEMS = 'DASHBOARD_SET_ITEMS';
export const DASHBOARD_SET_USER = 'DASHBOARD_SET_USER';

